import * as React from "react";

export const CenteredCode = ({children}) => (<pre style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}}>{children}</pre>);